define('SageDotCom/Utility/sageMatchHeight',["jquery", "matchHeight", "SageDotCom/PolyFills/closest"
], function ($) {
    function SageMatchHeight() {
        $.fn.matchHeight._maintainScroll = true;
        $.fn.matchHeight._throttle = 150;

        this.applyInitialBindings();
    }

    SageMatchHeight.prototype.applyInitialBindings = function applyInitialBindings() {
        var that = this;
        var defaultOptions = {
            byRow: false,
            property: 'height',
            target: null,
            remove: false
        };

        $(".matchheight-stylebox .score-style-box").matchHeight(defaultOptions);

        $(".score-carousel").each(function () {
            that.carouselBindings($(this), false);
        });

        $('.score-slick-slider').each(function () {
            that.findHighlightsAndApply(this, false);
            $(this).find(".sage-product-card-outer").matchHeight({ byRow: true });
            $(this).find(".score-slick-slider-panel").matchHeight({ byRow: true });
        });

        $('.campaign-carousel').each(function () {
            $(this).find('.score-hero, .score-section-hero').matchHeight(defaultOptions);
            $(this).find('.score-carousel-pic-pane-body').matchHeight(defaultOptions);
        });

        $('.score-tab.vertical-tabset .tab-content-wrapper-outer.tabAccordion-tabSet').each(function () {
            $(this).find('.tab-pane').matchHeight(defaultOptions);
        });

        $('.score-tab.vertical-tabAccordion .tab-content-wrapper-outer.tabAccordion-tabSet').each(function () {
            that.findHighlightsAndApply(this, false);
            $(this).find('.tab-pane:not(.sage-tab-home .tab-content-wrapper-outer.tabAccordion-tabSet .tab-pane)').matchHeight(defaultOptions);
        });

        $(".score-flex-box.slick-contents").each(function () {
            that.findHighlightsAndApply(this, false);
            $(this).find('.flex-item').matchHeight({ byRow: true });
        });

        $(".score-flex-box.nested-alignment").each(function () {
            that.findHighlightsAndApply(this, false);
            $(this).find('.flex-item').matchHeight({ byRow: true });
        });


        this.updateAllHeights();
    }

    SageMatchHeight.prototype.findHighlightsAndApply = function findHighlightsAndApply(parentElem, refresh) {
        var that = this;
        that.applyBinding($(parentElem).find(".score-highlight.highlight__heading--colored .score-highlight-header"), refresh);
        that.applyBinding($(parentElem).find(".score-highlight.highlight--caption-white .score-highlight-body"), refresh);
        that.applyBinding($(parentElem).find(".score-highlight.highlight--caption-white .caption"), refresh);
        that.applyBinding($(parentElem).find(".score-highlight .score-highlight-header"), refresh, { byRow: true });
        that.applyBinding($(parentElem).find(".score-highlight .score-highlight-body"), refresh, { byRow: true });
        that.applyBinding($(parentElem).find(".score-highlight .score-call-to-action"), refresh, { byRow: true });
        that.applyBinding($(parentElem).find(".score-highlight .caption"), refresh, { byRow: true });
        that.applyBinding($(parentElem).find(".score-highlight .image-wrapper"), refresh, { byRow: true });
        that.applyBinding($(parentElem).find(".score-highlight"), refresh, { byRow: false });
    }

    // use when html structure has changed (eg. new tag created/removed in js)
    SageMatchHeight.prototype.applyBinding = function applyBinding(items, refresh, options) {
        var defaultOptions = {
            byRow: false,
            property: 'height',
            target: null,
            remove: false
        };

        options = options === null || options === undefined || options === "" ? defaultOptions : options;

        if (refresh) {
            $(items).matchHeight({ remove: true });
        }

        $(items).matchHeight(options);
    }

    SageMatchHeight.prototype.removeBinding = function applyBinding(items) {
        $(items).matchHeight({ remove: true });
    }

    SageMatchHeight.prototype.carouselBindings = function carouselBindings(carousel, refresh, options) {
        var that = this;
        that.applyBinding(carousel.find(".score-hero, .score-section-hero"), refresh, options);
        that.findHighlightsAndApply(carousel, refresh);
        that.applyBinding(carousel.find(".score-carousel-pane-body:not(.score-carousel-pic-pane-body)"), refresh, options);
        that.applyBinding(carousel.find(".score-carousel-pic-pane"), refresh, options);
    }

    SageMatchHeight.prototype.agnosticProductCardBindings = function agnosticProductCardBindings(refresh, options) {
        var that = this;
        //Header
        that.applyBinding($(".sage-agnostic-product-card-header"), refresh, options);

        //Select box / anything above the main price line
        that.applyBinding($(".agnostic-product-card-pricing .above-price-section .selector-section"), refresh, options);
        that.applyBinding($(".agnostic-product-card-pricing .above-price-section"), refresh, options);

        //Main price line
        that.applyBinding($(".agnostic-product-card-pricing .pricing-information"), refresh, options);
        that.applyBinding($(".agnostic-product-card-pricing .price-section.base-price-section"), refresh, options);
        that.applyBinding($(".agnostic-product-card-pricing .price-section.addon-price-section"), refresh, options);

        //Add on toggle
        that.applyBinding($(".agnostic-product-card-pricing .sage-product-card-addon-alt"), refresh, options);

        //Everything in total
        that.applyBinding($(".agnostic-product-card-pricing"), refresh, options);

        //Footer components
        //Footer top section
        that.applyBinding($(".agnostic-product-card-footer-top"), refresh, options);
        //Footer bottom section
        that.applyBinding($(".agnostic-product-card-footer-bottom .main-footer-content"), refresh, options);
        that.applyBinding($(".agnostic-product-card-footer-bottom"), refresh, options);

        that.applyBinding($(".sage-agnostic-product-card-container"), refresh, options);
    }

    SageMatchHeight.prototype.productCardBindings = function productCardBindings(cardsParent, refresh, options) {
        var that = this;
        that.applyBinding(cardsParent.find(".sage-product-card-content-alt"), refresh, options);
        that.applyBinding(cardsParent.find(".sage-product-card-features-alt"), refresh, options);
        that.applyBinding(cardsParent.find(".sage-product-card-titles-container"), refresh, options);
        that.applyBinding(cardsParent.find(".sage-product-card-section-title-alt"), refresh, options);
        that.applyBinding(cardsParent.find(".sage-product-card-title"), refresh, options);
        that.applyBinding(cardsParent.find(".sage-product-card-subtitle"), refresh, options);
        that.applyBinding(cardsParent.find(".sage-product-card-price-selection"), refresh, options);
        that.applyBinding(cardsParent.find(".sage-product-card-price-options-area"), refresh, options);
        that.applyBinding(cardsParent.find(".sage-product-card-actions-area"), refresh, options);
        that.applyBinding(cardsParent.find(".sage-product-card-addon-alt"), refresh, options);
        that.applyBinding(cardsParent.find(".body .sage-product-card-features-alt"), refresh, options);
        that.applyBinding(cardsParent.find(".header"), refresh, options);
        that.applyBinding(cardsParent.find(".body"), refresh, options);
        that.applyBinding(cardsParent.find(".footer"), refresh, options);
    }


    // update all exisiting bindings (use when just trying to update the heights eg. on resize)
    SageMatchHeight.prototype.updateAllHeights = function updateAllHeights() {
        // add timeout to ensure if triggered by page resize, the resize is complete before tryng to change the heights
        clearTimeout(window.matchHeightResizeTimeout);
        window.matchHeightResizeTimeout = setTimeout(() => $.fn.matchHeight._update(), 150);
    }

    // static func
    SageMatchHeight.init = function init() {
        return new SageMatchHeight();
    }

    return SageMatchHeight;
});

